import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.js';

/**
 * Route guard for admin-only pages. Forces the /me bootstrap like
 * ProtectedRoute does, then checks the role. Non-admins are bounced to /me
 * rather than /login (they're authenticated, just not authorized).
 */
export function AdminRoute({ children }: { children: React.ReactNode }): JSX.Element | null {
  const { user, loading, bootstrap } = useAuth();

  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'admin') return <Navigate to="/me" replace />;
  return <>{children}</>;
}
